import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { PhoneNumber } from 'interfaces/phone-number'

const fetchUserPhoneNumbers = async (userId: string) => {
  const response = await fetch(
    `${BASE_API_URL}/admin/api/v2/phone_numbers?user_id=${userId}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  const handledResponse = handleErrors(response)
  const json = await handledResponse.json()

  // The API returns { data: [phone_numbers_array] }
  return json.data as PhoneNumber[]
}

const useGetUserPhoneNumbers = (userId?: string) => {
  return useQuery(
    ['user-phone-numbers', userId],
    () => fetchUserPhoneNumbers(userId!),
    {
      enabled: !!userId,
      refetchOnWindowFocus: false,
      staleTime: 300000,
    }
  )
}

export default useGetUserPhoneNumbers
